import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ErrorPage = () => {
  const location = useLocation();
  const errorMessage = location.state?.message || "Si è verificato un errore";

  return (
    <div className="error-page">
      <h1>Oops!</h1>
      <p>{errorMessage}</p>
      <Link to="/home" className="btn btn-primary">Torna alla Home</Link>
    </div>
  );
};

export default ErrorPage;
